import React from 'react'
import { useSelector } from 'react-redux';
import storePersist from '../../../../../redux/storePersist';
import { selectListItems } from '../../../../../redux/library/selector';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';

export default function RegistiesFilterComponent({ handleFormChange, selectedGateway, handleInnerFormChange, apply }: any) {
  const countries = storePersist.get('countries').current?.items;
  const libraryData = useSelector(selectListItems)
  const types = [
    { Id: 1, "Name": "sellerApp", "value": "sellerApp" },
    { Id: 2, "Name": "buyerApp", "value": "buyerApp" },
  ]
  const domains = [
    { Id: 1, "Name": "ONDC:RET10", "value": "ONDC:RET10" },
    { Id: 2, "Name": "ONDC:RET11", "value": "ONDC:RET11" },
    { Id: 3, "Name": "ONDC:RET12", "value": "ONDC:RET12" },
    { Id: 4, "Name": "ONDC:RET13", "value": "ONDC:RET13" },
    { Id: 5, "Name": "ONDC:RET14", "value": "ONDC:RET14" },
    { Id: 6, "Name": "ONDC:RET15", "value": "ONDC:RET15" },
    { Id: 7, "Name": "ONDC:RET16", "value": "ONDC:RET16" },
    { Id: 8, "Name": "ONDC:RET17", "value": "ONDC:RET17" },
    { Id: 9, "Name": "ONDC:RET18", "value": "ONDC:RET18" },
    { Id: 9, "Name": "ONDC:RET19", "value": "ONDC:RET19" },
  ]
  const Cities = [
    { Id: 1, "Name": "Bangalore", "value": "std:080", "state": "Tamil Nadu", CreatedOnUtc: "2024-09-30T06:21:14.954Z" },
    { Id: 2, "Name": "Chennai", "value": "std:044", "state": "Tamil Nadu", CreatedOnUtc: "2024-09-30T06:21:14.954Z" },
    { Id: 3, "Name": "Coimbatore", "value": "std:0422", "state": "Tamil Nadu", CreatedOnUtc: "2024-09-30T06:21:14.954Z" },
    { Id: 4, "Name": "Madurai", "value": "std:0452", "state": "Tamil Nadu", CreatedOnUtc: "2024-09-30T06:21:14.954Z" },
    { Id: 5, "Name": "Salem", "value": "std:0427", "state": "Tamil Nadu", CreatedOnUtc: "2024-09-30T06:21:14.954Z" },
    { Id: 6, "Name": "Tirupur", "value": "std:0421", "state": "Tamil Nadu", CreatedOnUtc: "2024-09-30T06:21:14.954Z" },
    { Id: 7, "Name": "Erode", "value": "std:0424", "state": "Tamil Nadu", CreatedOnUtc: "2024-09-30T06:21:14.954Z" },
    { Id: 8, "Name": "Trichy", "value": "std:0431", "state": "Tamil Nadu", CreatedOnUtc: "2024-09-30T06:21:14.954Z" },
    { Id: 9, "Name": "Virudhunagar", "value": "std:04562", "state": "Tamil Nadu", CreatedOnUtc: "2024-09-30T06:21:14.954Z" },
    { Id: 10, "Name": "Trichur", "value": "std:0487", "state": "Kerala", CreatedOnUtc: "2024-09-30T06:21:14.954Z" },
  ]
  return (
    <>
      <AccordionContainer
        child={
          <div className='flex flex-col'>
            <div className=' grid md:grid-cols-5 lg:grid-cols-5 gap-4'>

              <InputContainer
                label="Subscriber Id"
                name="subscriber_id"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'subscriber_id',
                  )
                }}
                type="text"
                value={selectedGateway?.subscriber_id}
              />

              <InputContainer
                label="Type *"
                labelField="Name"
                list={types}
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'type',
                  )
                }}
                type="select"
                valueField="value"
                value={selectedGateway?.type}
              />
              <InputContainer
                label="Domain Name *"
                labelField="Name"
                list={domains}
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'domain',
                  )
                }}
                type="select"
                valueField="value"
                value={selectedGateway?.domain}
              />

              <InputContainer
                label="Country Name *"
                labelField="Name"
                list={countries}
                onValueChange={(event: any, newValue: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'country',
                  );
                }}
                optionName='Choose Country'
                type="select"
                value={selectedGateway?.country}
                valueField="ThreeLetterIsoCode"
              />

              <InputContainer
                label="Cities"
                labelField="Name"
                list={Cities}
                onValueChange={(event: any, newValue: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'city',
                  )
                }}
                type="select"
                valueField="value"
                value={selectedGateway?.city}
              />
            </div>
            <div className='flex flex-row justify-end items-end'>
            <button
              onClick={() => apply(selectedGateway)}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 w-40 justify-start"
            >
              Search Registry
            </button>
            </div>
          </div>
        }
        expandedPanel="userInfo"
        headerTitle="Filters"
      />

    </>
  )
}